export default "__VITE_ASSET__BSGd$mbZ__"